import { render, staticRenderFns } from "./PaiBanModal.vue?vue&type=template&id=ba3382e4&scoped=true&"
import script from "./PaiBanModal.vue?vue&type=script&lang=js&"
export * from "./PaiBanModal.vue?vue&type=script&lang=js&"
import style0 from "./PaiBanModal.vue?vue&type=style&index=0&id=ba3382e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3382e4",
  null
  
)

export default component.exports